import { API } from '@brg/api';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { getThematicContent } from '../../../../../actions/getThematicContent';
import MoreModule from './moreblock';
var getItemsContent = function (list, t, thematicProps, i18n) {
    var _a = thematicProps || {}, theme = _a.theme, isArea = _a.isArea, thematic = _a.thematic, areaName = _a.areaName;
    return list && list.length
        ? list.map(function (item) {
            if (!item) {
                return {};
            }
            var image = item.titleImages && item.titleImages.length
                ? item.titleImages[1] && item.titleImages[1].url || item.titleImages[0].url
                : '';
            var link = item.longreadId
                ? item.countryId
                    ? "/story/".concat(item.longreadId, "/").concat(item.countryId, "/main")
                    : "/story/".concat(item.longreadId, "/").concat(item.areaId ||
                        (item.country && item.country.areaId), "/main?isArea=true&thematic=").concat(item.typeLongread || thematic)
                : item.countryId
                    ? '/country/' + item.countryId
                    : '/country/' + item.areaId;
            var location = (isArea && !item.country)
                ? areaName
                : (item.country && API.toLang({ name: item.country.namePrefixes }, i18n && i18n.language || 'ru').name +
                    ' ' + API.toLang({ name: item.country.name }, i18n && i18n.language || 'ru').name) || '';
            var title = API.toLang({ name: item.name }, i18n && i18n.language || 'ru').name;
            // console.log('getItemsContent', item, title, 'location', location);
            var post = {
                attachments: [{
                        file: item.titleImages && item.titleImages.length && item.titleImages[0].url || '',
                        files: item.titleImages || [],
                    }]
            };
            return { image: image, post: post, link: link, theme: theme, title: title, location: location };
        })
        : undefined;
};
var MoreContainer = function (props) {
    var specBlockProps = props.specBlockProps, t = props.t;
    var _a = specBlockProps || {}, contentThematicProps = _a.contentThematicProps, error = _a.error;
    var dispatch = useDispatch();
    var prevProps = useRef({});
    var contentThematicData = useSelector(function (state) { return state.thematicContent; });
    var _b = contentThematicData || {}, data = _b.data, errorData = _b.error, isFetching = _b.isFetching, isError = _b.isError;
    useEffect(function () {
        var _a, _b, _c;
        var getProps = {
            thematic: contentThematicProps === null || contentThematicProps === void 0 ? void 0 : contentThematicProps.thematic,
            areaId: contentThematicProps === null || contentThematicProps === void 0 ? void 0 : contentThematicProps.areaId,
            countryId: contentThematicProps === null || contentThematicProps === void 0 ? void 0 : contentThematicProps.countryId,
        };
        if (!contentThematicProps ||
            ((((_a = prevProps === null || prevProps === void 0 ? void 0 : prevProps.current) === null || _a === void 0 ? void 0 : _a.thematic) === getProps.thematic) &&
                (((_b = prevProps === null || prevProps === void 0 ? void 0 : prevProps.current) === null || _b === void 0 ? void 0 : _b.areaId) === getProps.areaId) &&
                (((_c = prevProps === null || prevProps === void 0 ? void 0 : prevProps.current) === null || _c === void 0 ? void 0 : _c.countryId) === getProps.countryId)) ||
            isFetching || isError) {
            return;
        }
        prevProps.current = getProps;
        dispatch(getThematicContent(getProps));
    }, [contentThematicProps, data, isFetching]);
    useEffect(function () {
        if (errorData && typeof (errorData.message) === 'string' && typeof (error) === 'function') {
            error(errorData.message);
        }
    }, [errorData]);
    var items = useMemo(function () {
        if (!data) {
            return undefined;
        }
        return data && data.length
            ? getItemsContent(data.slice(0, 4), t, contentThematicProps)
            : undefined;
    }, [data]);
    // console.log('MoreContainer', props, contentThematicData, data, items);
    return React.createElement(React.Fragment, null, items && items.length
        ? React.createElement(MoreModule, { items: items, specBlockProps: specBlockProps })
        : 'There are no other longreads yet.');
};
export default MoreContainer;
//# sourceMappingURL=morecontainer.js.mapimport { API } from '@brg/api';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { getThematicContent } from '../../../../../actions/getThematicContent';
import MoreModule from './moreblock';
var getItemsContent = function (list, t, thematicProps, i18n) {
    var _a = thematicProps || {}, theme = _a.theme, isArea = _a.isArea, thematic = _a.thematic, areaName = _a.areaName;
    return list && list.length
        ? list.map(function (item) {
            if (!item) {
                return {};
            }
            var image = item.titleImages && item.titleImages.length
                ? item.titleImages[1] && item.titleImages[1].url || item.titleImages[0].url
                : '';
            var link = item.longreadId
                ? item.countryId
                    ? "/story/".concat(item.longreadId, "/").concat(item.countryId, "/main")
                    : "/story/".concat(item.longreadId, "/").concat(item.areaId ||
                        (item.country && item.country.areaId), "/main?isArea=true&thematic=").concat(item.typeLongread || thematic)
                : item.countryId
                    ? '/country/' + item.countryId
                    : '/country/' + item.areaId;
            var location = (isArea && !item.country)
                ? areaName
                : (item.country && API.toLang({ name: item.country.namePrefixes }, i18n && i18n.language || 'ru').name +
                    ' ' + API.toLang({ name: item.country.name }, i18n && i18n.language || 'ru').name) || '';
            var title = API.toLang({ name: item.name }, i18n && i18n.language || 'ru').name;
            // console.log('getItemsContent', item, title, 'location', location);
            var post = {
                attachments: [{
                        file: item.titleImages && item.titleImages.length && item.titleImages[0].url || '',
                        files: item.titleImages || [],
                    }]
            };
            return { image: image, post: post, link: link, theme: theme, title: title, location: location };
        })
        : undefined;
};
var MoreContainer = function (props) {
    var specBlockProps = props.specBlockProps, t = props.t;
    var _a = specBlockProps || {}, contentThematicProps = _a.contentThematicProps, error = _a.error;
    var dispatch = useDispatch();
    var prevProps = useRef({});
    var contentThematicData = useSelector(function (state) { return state.thematicContent; });
    var _b = contentThematicData || {}, data = _b.data, errorData = _b.error, isFetching = _b.isFetching, isError = _b.isError;
    useEffect(function () {
        var _a, _b, _c;
        var getProps = {
            thematic: contentThematicProps === null || contentThematicProps === void 0 ? void 0 : contentThematicProps.thematic,
            areaId: contentThematicProps === null || contentThematicProps === void 0 ? void 0 : contentThematicProps.areaId,
            countryId: contentThematicProps === null || contentThematicProps === void 0 ? void 0 : contentThematicProps.countryId,
        };
        if (!contentThematicProps ||
            ((((_a = prevProps === null || prevProps === void 0 ? void 0 : prevProps.current) === null || _a === void 0 ? void 0 : _a.thematic) === getProps.thematic) &&
                (((_b = prevProps === null || prevProps === void 0 ? void 0 : prevProps.current) === null || _b === void 0 ? void 0 : _b.areaId) === getProps.areaId) &&
                (((_c = prevProps === null || prevProps === void 0 ? void 0 : prevProps.current) === null || _c === void 0 ? void 0 : _c.countryId) === getProps.countryId)) ||
            isFetching || isError) {
            return;
        }
        prevProps.current = getProps;
        dispatch(getThematicContent(getProps));
    }, [contentThematicProps, data, isFetching]);
    useEffect(function () {
        if (errorData && typeof (errorData.message) === 'string' && typeof (error) === 'function') {
            error(errorData.message);
        }
    }, [errorData]);
    var items = useMemo(function () {
        if (!data) {
            return undefined;
        }
        return data && data.length
            ? getItemsContent(data.slice(0, 4), t, contentThematicProps)
            : undefined;
    }, [data]);
    // console.log('MoreContainer', props, contentThematicData, data, items);
    return React.createElement(React.Fragment, null, items && items.length
        ? React.createElement(MoreModule, { items: items, specBlockProps: specBlockProps })
        : 'There are no other longreads yet.');
};
export default MoreContainer;
//# sourceMappingURL=morecontainer.js.map